import { render, staticRenderFns } from "./CellTable.vue?vue&type=template&id=5fb3255a"
import script from "./CellTable.vue?vue&type=script&lang=js"
export * from "./CellTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports